
import { createSelector } from '@ngrx/store';

import {
  selectVistaUsuario,
  VistaUsuarioState
} from '../../vista-usuario/vista-usuario.state';

import { entitySitiosProcesamientoAdapter, EntitySitiosProcesamientoState } from './sitios-procesamiento.state';
import { selectCurrentEmpresa } from '../../empresas/entity-mis-empresas/entity-current-empresa.selectors';

const { selectEntities, selectAll } = entitySitiosProcesamientoAdapter.getSelectors();

export const getError = (state: EntitySitiosProcesamientoState): any => state.error;

export const getIsLoading = (state: EntitySitiosProcesamientoState): boolean =>
  state.isLoading;

export const getHasAddedSuccess = (state: EntitySitiosProcesamientoState): boolean =>
  state.hasAddedSuccess;

export const selectSitiosProcesamientoState = createSelector(
  selectVistaUsuario,
  (state: VistaUsuarioState) => state.sitiosProcesamiento
);

export const selectAllSitiosProcesamiento = createSelector(selectSitiosProcesamientoState, selectAll);
export const selectEntitiesSitiosProcesamiento = createSelector(
  selectSitiosProcesamientoState,
  selectEntities
);

// MemoizedSelector<object,any>
export const selectSitiosProcesamientoError = createSelector(
  selectSitiosProcesamientoState,
  getError
);

// MemoizedSelector<object,any>
export const selectSitiosProcesamientoIsLoading = createSelector(
  selectSitiosProcesamientoState,
  getIsLoading
);

export const selectAllSitiosProcesamientoFromCurrentEmpresa = createSelector(
  selectAllSitiosProcesamiento,
  selectCurrentEmpresa,
  (sitiosProcesamiento, currentEmpresa) => {
    if (sitiosProcesamiento && currentEmpresa) {
      return sitiosProcesamiento.filter((sp) => sp.entidad_productiva_id == currentEmpresa.id)
    } else {
      return []
    }
  }
);

export const selectSitioProcesamientoById = (sitioProcesamientoId: number) => createSelector(
  selectAllSitiosProcesamiento,
  (sitiosProcesamiento) =>
    sitiosProcesamiento.find((sp) => sp.id == sitioProcesamientoId)
);

export const selectSitiosProcesamientoAddedSuccess = createSelector(
  selectSitiosProcesamientoState,
  getHasAddedSuccess
);
